import { Suspense } from "react";
import { Outlet } from "react-router-dom";

import { Loader } from "@/shared/ui/Loader/Loader";
import { ProgressBar } from "@/shared/ui/ProgressBar/ProgressBar";

export const App = () => {
    return (
        <>
            <main>
                <Suspense fallback={<Loader />}>
                    <Outlet />
                </Suspense>
            </main>
            <ProgressBar />
        </>
    );
};
